import React, { useEffect, useState } from 'react';
import DataCell from './DataCell';

const TextInputCell = ({
    rowIndex,
    data,
    accessor,
    scrollPxH,
    scrollPxV,
    isSticky,
    style,
    onHover,
    isHighlighted,
    onKeyPress,
    rowHeight,
    deleteRowSelected,
    highlightedIdx,
    setHighlightedIdx,
    highlightOnClick = false
}) => {
    const [value, setValue] = useState(data[accessor]);
    useEffect(() => {
        setValue(data[accessor]);
    }, [data[accessor]]);

    const handleKeyUp = (event) => {
        // When hit Enter, trigger blur event. This indicates the changes made by losing focus.
        if (event.key === 'Enter') {
            event.target.blur();
        }
    };

    return (
        <DataCell
            rowIndex={rowIndex}
            scrollPxH={scrollPxH}
            scrollPxV={scrollPxV}
            id={`${accessor}${rowIndex}`}
            isSticky={isSticky}
            onHover={onHover}
            isHighlighted={isHighlighted}
            deleteRowSelected={deleteRowSelected}
            style={{
                textAlign: 'left',
                backgroundColor: '#FFFDF4',
                padding: 0,
                height: rowHeight,
                ...style
            }}
            highlightedIdx={highlightedIdx}
            setHighlightedIdx={setHighlightedIdx}
            highlightOnClick={highlightOnClick}
        >
            <input
                type='text'
                id={`text-input-cell-${accessor}`}
                name={`text-input-cell-${accessor}`}
                style={{
                    appearance: 'none',
                    MozAppearance: 'none',
                    WebkitAppearance: 'none',
                    height: '100%',
                    width: 'calc(100% - 20px)',
                    border: 'none',
                    backgroundColor: '#00000000',
                    padding: '0 10px',
                    borderRadius: 0
                }}
                value={value}
                onChange={(event) => {
                    setValue(event.target.value);
                }}
                onKeyPress={(event) => {
                    onKeyPress(event, {
                        ...data,
                        [accessor]: value
                    });
                }}
                onKeyUp={handleKeyUp}
            />
        </DataCell>
    );
};

export default TextInputCell;
